import React, { useEffect, useState } from 'react';
import './LoadingScreen.css';

const LoadingScreen = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const durationMs = 1800;
    const start = performance.now();
    let rafId;

    const tick = (now) => {
      const elapsed = now - start;
      const ratio = Math.min(elapsed / durationMs, 1);
      const eased = 1 - Math.pow(1 - ratio, 3);
      setProgress(Math.round(eased * 100));

      if (ratio < 1) {
        rafId = requestAnimationFrame(tick);
      }
    };

    rafId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafId);
  }, []);

  return (
    <div className="loading-screen">
      <div className="loading-card">
        <p className="loading-label">Loading Workspace</p>
        <div className="loading-value">{progress}%</div>
        <div className="loading-track">
          <div className="loading-fill" style={{ width: `${progress}%` }} />
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
